// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components

// Images
import bgImage from "assets/images/bgg.jpg";
import BasicLayout from "../components/BasicLayout";
import { Grid } from "react-ionicons";
import { useState } from "react";
import { CircularProgress } from "@mui/material";
import MDSnackbar from "components/MDSnackbar";
import styled from "styled-components";
import { resetPassword, updatePassword } from "../api/authenticationApi";

function ResetPasswordForm() {
    const [isLoading, setIsLoagding] = useState(false);
    const [openSnackBar, setOpenSnackBar] = useState(null);
    const [pass, setPass] = useState('');
    const [errors, setErrors] = useState({ pass: '' });


    const handleResetPassword = async () => {

        if (!validateForm()) return;

        const urlParams = new URLSearchParams(window.location.search);
        const email = urlParams.get('email');
        const validationCode = urlParams.get('validationCode');

        await updatePassword(pass, email, validationCode)
            .then(async e => {

                console.log("ee", e)
                if (!e?.errorCode) {
                    setIsLoagding(false);
                    if (e?.redirectUrl) {
                        window.location.href = e.redirectUrl;
                    } else {
                        window.location.href = '/';
                    }

                } else {
                    setOpenSnackBar({ message: e?.message })
                }
                return e;
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => setIsLoagding(false))
    }

    const validateForm = () => {
        let valid = true;
        const newErrors = { pass: '' };

        // if (!email) {
        //     newErrors.email = "Email é obrigatório";
        //     valid = false;
        // } else if (!/\S+@\S+\.\S+/.test(email)) {
        //     newErrors.email = "Formato de email inválido";
        //     valid = false;

        //     setErrors(newErrors);
        // }
        return valid;
    }

    return (
        <>
            <BasicLayout image={bgImage}>
                <Card>
                    <StyledContent
                        variant="gradient"
                        bgColor="info"
                        borderRadius="lg"
                        coloredShadow="info"
                        mx={2}
                        mt={-3}
                        p={2}
                        mb={1}
                        textAlign="center"
                    >
                        <MDBox mt={-2} mb={-5}>
                            <img width={250} src="/p3602.png" />
                        </MDBox>
                    </StyledContent>
                    <MDBox pt={4} pb={3} px={3}>
                        <MDBox component="form" role="form">
                            <MDBox mb={2}>
                                <MDInput
                                    error={!!errors.pass}
                                    onChange={e => {
                                        setErrors({})
                                        setPass(e.target.value)
                                    }}
                                    type="password"
                                    label="Nova senha"
                                    fullWidth />
                                {!!errors.pass && <StyledSpan>{errors.pass}</StyledSpan>}
                            </MDBox>

                        </MDBox>
                        <MDBox mt={4} mb={1}>
                            <MDButton disabled={isLoading}
                                onClick={handleResetPassword}
                                variant="gradient" color="info" fullWidth>
                                {isLoading
                                    ? <CircularProgress color="inherit" size={16} />
                                    :
                                    'Redefinir senha'
                                }
                            </MDButton>
                            <MDBox mt={2} mb={1} />
                        </MDBox>
                    </MDBox>
                </Card>
            </BasicLayout>

            <MDSnackbar
                icon="check"
                open={openSnackBar}
                color="error"
                title={openSnackBar?.message}
                onClose={() => setOpenSnackBar(false)}
                close={() => setOpenSnackBar(false)}
            />
        </>
    );
}

const StyledContent = styled(MDBox)`
  background: radial-gradient(circle at 135% 651%, #f28371 79%, #f28371 1%, transparent 0%) ,#f0ba8d !important; 
  heigth: 100px 
`;

const StyledSpan = styled.span`
  color: red;
  font-size:10px;
  display:flex;
`;

const StyledResetPassDiv = styled.div`
  justify-content: flex-end;
  display: flex;
  padding: 5px 5px 0 0;

  span {
    font-size: 0.8rem !important;
    cursor: pointer;
  }
`;

export default ResetPasswordForm;
